import React from "react";
import {
  Grid,
  Typography,
  Box,
} from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { StyledButton } from '../../common/styledComponents/AuthComponents';


interface OwnProps {
  doneClickHandler: () => void
}

const ResetPasswordError = (props: OwnProps) => {
  return (
    <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ width: '100%' }}>
      <Box sx={{ 
        backgroundColor: theme => theme.palette.error.light,
        borderRadius: '50%',
        width: 80,
        height: 80,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mb: 3
      }}>
        <ErrorOutline sx={{ 
          color: theme => theme.palette.error.dark, 
          fontSize: 40 
        }} />
      </Box>
      
      <Typography 
        variant="h5" 
        fontWeight="600" 
        color="error" 
        align="center" 
        gutterBottom 
        data-cy="resetRequestErrorHeader"
      >
        Reset Password Link Invalid
      </Typography>

      <Box sx={{ 
        backgroundColor: theme => theme.palette.grey[50],
        borderRadius: '8px',
        p: 3,
        mb: 4,
        maxWidth: '400px',
        border: theme => `1px solid ${theme.palette.grey[200]}`
      }}>
        <Typography 
          align="center" 
          variant="body1"
        >
          This reset password link is no longer valid. Please request a new link to reset your password.
        </Typography>
      </Box>
      
      <StyledButton 
        variant="contained" 
        onClick={props.doneClickHandler} 
        data-cy="homepageButton"
        fullWidth
        size="large"
        sx={{ maxWidth: '400px' }}
      >
        Return to Home Page
      </StyledButton>
    </Grid>
  )
}

export default ResetPasswordError;
